import { Input } from 'antd';
import type { Control, FieldErrors } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { PresetFormValues } from '../../../lib/types';
import { DynamicStringList } from '../dynamic-string-list';
import { PresetFormItem } from '../form-item';
import styles from '../preset-form.module.scss';

interface ContentSettingsProps {
  control: Control<PresetFormValues>;
  errors: FieldErrors<PresetFormValues>;
  disabled?: boolean;
}

export const ContentSettings = ({ control, errors, disabled }: ContentSettingsProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets.editor.content' });

  return (
    <div className={styles.fieldsGrid}>
      <PresetFormItem label={t('buttonText')} error={errors.content?.button_text?.message} required>
        <Controller
          control={control}
          name="content.button_text"
          render={({ field }) => (
            <Input
              {...field}
              disabled={disabled}
              placeholder={t('buttonTextPlaceholder')}
              maxLength={80}
              showCount
            />
          )}
        />
      </PresetFormItem>

      <PresetFormItem
        label={t('assistantName')}
        error={errors.content?.assistant_name?.message}
        required
      >
        <Controller
          control={control}
          name="content.assistant_name"
          render={({ field }) => (
            <Input
              {...field}
              disabled={disabled}
              placeholder={t('assistantNamePlaceholder')}
              maxLength={80}
              showCount
            />
          )}
        />
      </PresetFormItem>

      <PresetFormItem
        label={t('welcomeMessage')}
        description={t('welcomeMessageDescription')}
        error={errors.content?.welcome_message?.message}
        fullWidth
        required
      >
        <Controller
          control={control}
          name="content.welcome_message"
          render={({ field }) => (
            <Input.TextArea
              {...field}
              disabled={disabled}
              placeholder={t('welcomeMessagePlaceholder')}
              autoSize={{ minRows: 3, maxRows: 6 }}
              maxLength={1000}
              showCount
            />
          )}
        />
      </PresetFormItem>

      <PresetFormItem label={t('quickQuestions')} fullWidth>
        <DynamicStringList
          control={control}
          name="content.quick_questions"
          placeholder={t('quickQuestionPlaceholder')}
          addLabel={t('addQuickQuestion')}
          disabled={disabled}
        />
      </PresetFormItem>
    </div>
  );
};
